<template>
  <div>
    <div id="container" ref="container" class="display-nav">
      <div id="mapContainer"></div>
      <div id="canvas">
        <div id="nav">
          <div id="searchDiv">
            <el-date-picker v-model="searchTimeArray" :disabled="!queryLocationTrajectoryOperate" type="datetimerange" range-separator="-" :start-placeholder="labelBeginTime" :end-placeholder="labelEndTime" style="width: 360px"/>
            <el-button  class="search-btn" icon="el-icon-search" :disabled="!queryLocationTrajectoryOperate" @click="searchLocationTrajectory"/>
          </div>

          <div class="collapse-div">
            <el-collapse accordion>
              <el-collapse-item>
                <template slot="title">
                  &nbsp;&nbsp;&nbsp;{{$t('message.movingWarn')}}
                </template>

                <div class="baseSetting">
                  <div class="settingRow">
                    <span>{{$t('message.relocationAlert')}}：</span>
                    <el-switch v-model="moveConf" :active-value="1" :inactive-value="0" @change="emitMoveConf"/>
                  </div>

                  <div class="settingRow">
                    <span> {{$t('message.movingEffectiveTime')}}：</span>
                    <el-date-picker v-model="moveEffectiveTime" type="datetime" size="small" :disabled="moveConf == 0"/>
                  </div>

                  <div class="settingRow">
                    <span> {{$t('message.movingDistance')}}：</span>
                    <el-input size="small" class="location-input" type="text" :disabled="moveConf == 0" v-model="moveDistance"   @change="emitMoveDistance"/>
                    <span class="location-unit">M</span>
                  </div>

                  <div class="settingRow">
                    <span>{{$t('message.selectedLocation')}}：</span>
                    <span v-if="initLocationSettingType == 0">{{$t('message.selectedLocationTip1')}}</span>
                    <span v-else-if="initLocationSettingType == 1">{{$t('message.selectedLocationTip2')}}</span>
                    <span v-else>{{$t('message.selectedLocationTip3')}}</span>
                  </div>

                  <div class="settingRow" >
                    <span> {{$t('message.selectStartingPoint')}}：</span>
                    <el-select  v-model="initLocationSettingType" size="small" :disabled="moveConf == 0">
                      <el-option  v-show="hasLocation == 1" :key="0" :label="$t('message.optCurrentLocation')" :value="0" />
                      <el-option  v-show="hasInitLocation == 1" :key="1" :label="$t('message.optSelectLocation')" :value="1" />
                      <el-option :key="2" :label="$t('message.optSelectNewLocation')" :value="2" />
                    </el-select>
                  </div>
                </div>


                <div style="text-align:center; margin-top: 25px">
                  <el-button class="verifone-btn" type="primary" plain icon="el-icon-back" @click="cancel">{{$t('message.cancel')}}</el-button>
                  <el-button v-if="queryFlag" class="verifone-btn" type="primary" icon="el-icon-document" @click="saveMovingWarnConfig">{{$t('message.submit')}}</el-button>
                  <el-button v-else disabled class="verifone-btn" type="primary" icon="el-icon-document">{{$t('message.submit')}}</el-button>
                </div>
              </el-collapse-item>
              <el-collapse-item>
                <template slot="title">
                  &nbsp;&nbsp;&nbsp;{{$t('message.movingTrack')}}
                </template>

                <div class="baseSetting">
                  <div class="settingRow">
                    <span style="display:inline-block;vertical-align:middle;text-align: center;margin-bottom: 1rem">{{$t('message.movingTrackSwitch')}}：</span>
                    <el-switch  style="margin-bottom: 1rem;" v-model="isAllowUploadLocationInfo" :disabled="uploadLocationOperate != 0"  :active-value="1" :inactive-value="0"   @change="saveMovingTrackConfig"></el-switch>
                    <div style="display:inline-block;margin-bottom: 1rem;">
                      <el-tooltip class="item" effect="dark" v-if="uploadLocationOperate == 1" :content="$t('message.locationUploadAlert1')" placement="right">
                        <span >&emsp;<img  src='static/img/LocationStrack.png' style="height: 25px;width: 25px;"></span>
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" v-else-if="uploadLocationOperate == 2" :content="$t('message.locationUploadAlert2')" placement="right">
                        <span >&emsp;<img  src='static/img/LocationStrack.png' style="height: 25px;width: 25px;"></span>
                      </el-tooltip>
                    </div>
                  </div>
                </div>

              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
        <a href="#" class="toggle-nav" id="bars" @click="toggleNavigation()"><i class="el-icon-arrow-left" ref="settingBtn"></i></a>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "TerminalEditLocationService",

        props:{
          superMoveConf:{
            required: true
          },
          superMoveDistance:{
            required: true
          },
          superMoveEffectiveTime:{
            required: true
          },
          superIsAllowUploadLocationInfo:{
            required:true
          },
          superUploadLocationInfoInterval:{
            required:true
          },
          terminalLat:{
            required: true
          },
          terminalLng:{
            required: true
          },
          locationUploadTime:{
            required:true
          },
          sn:{
            required: true
          },
          queryFlag:{
            required: true
          },
          terminalMoveConfigInitialLat:{
            required:true
          },
          terminalMoveConfigInitialLng:{
            required:true
          },
          uploadLocationOperate:{
            required:true
          },
          queryLocationTrajectoryOperate:{
            required:true
          },
          terminalId:{
            required:true
          },
          superInitLocationSettingType:{
            required:true
          }
        },

        data(){
          return{
            labelBeginTime: this.$t('message.beginTime'),
            labelEndTime: this.$t('message.endTime'),

            moveConf:'0', // 移机警告是否开启，0：否()，1：是
            moveDistance:'1000', // 移机警告触发的阈值
            moveEffectiveTime:'', // 移机警告生效时间
            isAllowUploadLocationInfo: '0', // 是否允许上送位置信息 0：不允许，1：允许
            uploadLocationInfoInterval:'', // 上送位置信息频率

            hasLocation:0, // 是否有初始位置， 0：否，1：是
            hasInitLocation: 0, // 是否已经设置过初始位置，0：否，1:是
            initLocationSettingType: "0", // 移机警告初始位置设置方式，0：使用默认位置，1：使用之前设置的位置，2：自定义位置

            qqMap:'', // 腾讯地图
            googleMap:'', // 谷歌地图
            flightPath:'', // 轨迹对象

            terminalMoveConfigLat:'', // 移机预警初始位置（纬度）
            terminalMoveConfigLng:'', // 移机预警初始位置（经度）
            terminalMoveConfigMarker:'', // 移机警报预警初始位置标记
            src:'static/img/LocationStrack.png',//预警图标
            searchTimeArray: [],
            trajectoryMessage:this.$t('message.trajectoryMessage'),//位置服务搜索提示

            no: this.$t('message.no'),
            yes: this.$t('message.yes'),
            warning: this.$t('message.warning'),
            openMovingTrackMsg: this.$t('message.openMovingTrackMsg'),
          }
        },

        watch:{
          superMoveConf:function(val) {
            this.moveConf = val;
          },
          superMoveDistance:function (val) {
            this.moveDistance = val;
          },
          superMoveEffectiveTime:function(val){
            this.moveEffectiveTime = val;
          },
          superIsAllowUploadLocationInfo: function(val) {
            this.isAllowUploadLocationInfo = val;
          },
          superUploadLocationInfoInterval: function(val){
            this.uploadLocationInfoInterval = val;
          },
          superInitLocationSettingType: function (val) {
            this.initLocationSettingType = val;
            this.hasInitLocation = val;
          },
          terminalLat:function () {
            this.mapInit();
          },
          terminalLng:function () {
            this.mapInit();
          },
          terminalMoveConfigInitialLat: function () {
            this.mapInit();
          },
          terminalMoveConfigInitialLng: function () {
            this.mapInit();
          }
        },

        methods:{
          emitMoveConf(moveConf){
            this.$emit("emitMoveConf",moveConf);
          },
          emitMoveDistance(moveDistance){
            this.$emit("emitMoveDistance",moveDistance);
          },
          saveMovingTrackConfig(isAllowUploadLocationInfo){
            let _this = this;
            if (isAllowUploadLocationInfo == 1)
              this.$confirm(this.openMovingTrackMsg,this.warning, {
                confirmButtonText: this.yes,
                cancelButtonText: this.no,
                type: 'warning'
              }).then(() => {
                this.$emit("saveMovingTrackConfig",isAllowUploadLocationInfo);
              }).catch(() => {
                _this.isAllowUploadLocationInfo = 0;
                console.log("saveMovingTrackConfig -> 用户取消")
              });
            else
              this.$emit("saveMovingTrackConfig",isAllowUploadLocationInfo);
          },
          emitUploadLocationInfoInterval(uploadLocationInfoInterval){
            this.$emit("emitUploadLocationInfoInterval",uploadLocationInfoInterval);
          },
          cancel(){
            this.$emit('cancel');
          },
          saveMovingWarnConfig(){
            this.$emit('saveMovingWarnConfig', this.terminalMoveConfigLat, this.terminalMoveConfigLng, this.moveEffectiveTime, this.initLocationSettingType);
          },
          save(){
            this.$emit('locationServerConfigSave', this.terminalMoveConfigLat, this.terminalMoveConfigLng, this.moveEffectiveTime);
          },
          mapInit(){
            if (sessionStorage.getItem('acceptLanguage') == 'en-US, en') {
              this.googleMapInit()
            }else{
              this.qqMapInit()
            }
          },
          googleMapInit(){
            let that = this,
              terminalLocationIcon = "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
              initLocationIcon = "http://maps.google.com/mapfiles/ms/icons/blue-dot.png";

            that.googleMap = new google.maps.Map(document.getElementById("mapContainer"), {
              zoom: 17,  //显示一个滑动条来控制map的Zoom级别
              zoomControl: false, // 删除地图上的“ 缩放”控件按钮。
              center: { lat: 13.982163, lng: 100.306070},  //设置地图中心点
              mapTypeId: 'roadmap',  // 控制地图的类型 roadmap：街道地图、terrain：地形地图、satellite：卫星地图、 hybrid：卫星图像+地名
            });

            // 设置初始地址标记
            if (!that.yyUtils.isBank(that.terminalMoveConfigInitialLat) && !that.yyUtils.isBank(that.terminalMoveConfigInitialLng)){
              that.terminalMoveConfigLat = this.terminalMoveConfigInitialLat;
              that.terminalMoveConfigLng = this.terminalMoveConfigInitialLng;

              let terminalMoveConfigLat = parseFloat(this.terminalMoveConfigLat),
                terminalMoveConfigLng = parseFloat(this.terminalMoveConfigLng);

              that.googleMap.setCenter({ lat: terminalMoveConfigLat, lng: terminalMoveConfigLng});

              that.terminalMoveConfigMarker = new google.maps.Marker({
                //标点的位置
                position: { lat: terminalMoveConfigLat, lng: terminalMoveConfigLng},
                map: that.googleMap,
                //标点的动画
                animation: google.maps.Animation.DROP,
                icon:initLocationIcon
              });
            }

            // 添加设备位置标记
            if (!that.yyUtils.isBank(this.terminalLat) && !that.yyUtils.isBank(this.terminalLng)){
              this.hasLocation = 1;
              let terminalLat = parseFloat(this.terminalLat),
                terminalLng = parseFloat(this.terminalLng);

              that.googleMap.setCenter({ lat: terminalLat, lng: terminalLng});

              let title = 'Lat:' + that.terminalLat
                + '\r\nLng:' + that.terminalLng
                + '\r\nReportTime:' + that.locationUploadTime;

              new google.maps.Marker({
                //标点的位置
                position: { lat: terminalLat, lng: terminalLng},
                map: that.googleMap,
                //标点的名称
                title: title,
                //标点的动画
                animation: google.maps.Animation.DROP,
                icon:terminalLocationIcon
              });
            }

            // 点击事件
            google.maps.event.addListener(that.googleMap, 'click', function (event) {
              if(that.initLocationSettingType !== 2 || that.moveConf != '1')
                return;

              that.terminalMoveConfigLat = event.latLng.lat();
              that.terminalMoveConfigLng = event.latLng.lng();
              console.log(that.terminalMoveConfigLat, that.terminalMoveConfigLng);

              // 清除先前的标记
              if (that.terminalMoveConfigMarker != ''){
                that.terminalMoveConfigMarker.setMap(null);
              }

              // 设置新的标记
              that.terminalMoveConfigMarker = new google.maps.Marker({
                //标点的位置
                position: event.latLng,
                map: that.googleMap,
                icon: initLocationIcon
              });
            })
          },

          qqMapInit(){
            let _this = this,
              terminalLocationIcon = new qq.maps.MarkerImage("static/img/redMarker.png"),
              initLocationIcon = new qq.maps.MarkerImage("static/img/blueMarker.png");

            _this.qqMap = new qq.maps.Map(
              document.getElementById("mapContainer"), // 容器
              {
                zoom: 16,
                center: new qq.maps.LatLng(26.08, 119.28), //Lat：纬度、Lng：经度
                mapTypeId: qq.maps.MapTypeId.ROADMAP
              }
            );

            // 设置初始地址Marker
            if (!_this.yyUtils.isBank(_this.terminalMoveConfigInitialLat) && !_this.yyUtils.isBank(_this.terminalMoveConfigInitialLng)){
              _this.terminalMoveConfigLat = _this.terminalMoveConfigInitialLat;
              _this.terminalMoveConfigLng = _this.terminalMoveConfigInitialLng;

              let terminalMoveConfigLat = parseFloat(_this.terminalMoveConfigLat),
                terminalMoveConfigLng = parseFloat(_this.terminalMoveConfigLng);

              _this.qqMap.setCenter(new qq.maps.LatLng(terminalMoveConfigLat, terminalMoveConfigLng));

              _this.terminalMoveConfigMarker =  new qq.maps.Marker({
                //设置Marker的位置坐标
                position: new qq.maps.LatLng(terminalMoveConfigLat, terminalMoveConfigLng),
                //设置显示Marker的地图
                map: _this.qqMap,
                icon : initLocationIcon
              });
            }

            // 设置设备位置Marker
            if (!_this.yyUtils.isBank(_this.terminalLat) && !_this.yyUtils.isBank(_this.terminalLng)){
              this.hasLocation = 1;
              let terminalLat = parseFloat(_this.terminalLat),
                terminalLng = parseFloat(_this.terminalLng);

              _this.qqMap.setCenter(new qq.maps.LatLng(terminalLat, terminalLng));

              let title = '纬度:' + _this.terminalLat
                + '\r\n经度:' + _this.terminalLng
                + '\r\n上报时间:' + _this.locationUploadTime;

              new qq.maps.Marker({
                //设置Marker的位置坐标
                title:title,
                position: new qq.maps.LatLng(terminalLat, terminalLng),
                //设置显示Marker的地图
                map: _this.qqMap,
                icon: terminalLocationIcon
              });
            }

            // 用户点击地图设置初始位置监听
            qq.maps.event.addListener(_this.qqMap, 'click', function(event){
              if(_this.initLocationSettingType !== 2 || _this.moveConf != '1')
                return;

              _this.terminalMoveConfigLat = event.latLng.getLat();
              _this.terminalMoveConfigLng = event.latLng.getLng();

              // 清除先前的标记
              if (_this.terminalMoveConfigMarker != ''){
                _this.terminalMoveConfigMarker.setMap(null);
              }

              // 设置新的标记
              _this.terminalMoveConfigMarker = new qq.maps.Marker({
                //标点的位置
                position: event.latLng,
                map: _this.qqMap,
                icon: initLocationIcon
              });
            })

          },

          searchLocationTrajectory(){
            let _this = this,
              obj = {
              beginTime: this.searchTimeArray[0],
              endTime: this.searchTimeArray[1],
              terminalId: this.terminalId
            }

            this.$axios({
              method: 'post',
              url: '/marketplace/terminal/searchLocationTrajectory',
              headers: {
                'Accept-Language': sessionStorage.getItem('acceptLanguage')
              },
              data: obj
            }).then(response => {
              if (response.data.code != "00") {
                this.yjMessage.showErrorMsg(response.data.desc);
                return;
              } else {
                _this.drawTrajectory(response.data.data);
              }
            }).catch((err) => {
              console.log(err);
            });
          },

          drawTrajectory(locationDataArray){
            if(locationDataArray.length == 0){
              if (this.flightPath != '')
                this.flightPath.setMap(null);

              this.$message({
                type: 'warning',
                message: this.trajectoryMessage,
                duration: '3000'
              });
              return;
            }

            if (sessionStorage.getItem('acceptLanguage') == 'en-US, en') {
              this.drawTrajectoryGoogle(locationDataArray)
            }else{
              this.drawTrajectoryQQ(locationDataArray)
            }
          },

          drawTrajectoryGoogle(locationDataArray){
            let myTrip=[];
            for (let i = 0, len = locationDataArray.length; i < len; i++) {
              myTrip.push(new google.maps.LatLng(locationDataArray[i].lat,locationDataArray[i].lng))
            }

            if (this.flightPath != '')
              this.flightPath.setMap(null);

            this.googleMap.setCenter(new google.maps.LatLng(locationDataArray[0].lat,locationDataArray[0].lng));

            this.flightPath = new google.maps.Polyline({
              path:myTrip,
              strokeColor:"#4BC378",
              strokeOpacity:0.8,
              strokeWeight:5,
            });

            this.flightPath.setMap(this.googleMap);
          },

          drawTrajectoryQQ(locationDataArray){
            let _this = this,
              myTrip=[];
            for (let i = 0, len = locationDataArray.length; i < len; i++) {
              myTrip.push(new qq.maps.LatLng(locationDataArray[i].lat,locationDataArray[i].lng))
            }

            if (this.flightPath != '')
              this.flightPath.setMap(null);

            this.qqMap.setCenter(new qq.maps.LatLng(locationDataArray[0].lat,locationDataArray[0].lng));

            this.flightPath = new qq.maps.Polyline({
              path:myTrip,
              strokeColor:"#4BC378",
              strokeOpacity:0.8,
              strokeWeight:5,
              map:_this.qqMap
            });

          },

          toggleNavigation() {
            if (this.yyUtils.isBank(this.$refs.container.className)) {
              this.$refs.container.className = 'display-nav';
              this.$refs.settingBtn.className = 'el-icon-arrow-left'
            }else{
              this.$refs.container.className = '';
              this.$refs.settingBtn.className = 'el-icon-arrow-right'
            }
          },

        }
    }
</script>

<style scoped>
  .location-unit {
    margin-left: 10px;
  }

  .location-input {
    width: 42%;
  }

  #container {
    width: 100%;
    height: 75vh;
    position: relative;
    overflow: hidden;
  }

  #mapContainer{
    width: 100%;
    height: 98%;
    position: absolute;
  }

  #canvas {
    height: 100%;
    padding: 3% 0;
    position: absolute;

    -webkit-transform:translateX(0);
    -moz-transform:translateX(0);
    -ms-transform:translateX(0);
    -o-transform:translateX(0);
    transform:translateX(0);

    -webkit-transition:.5s ease all;
    -moz-transition:.5s ease all;
    -o-transition:.5s ease all;
    transition:.5s ease all;
  }

  #nav {
    width: 430px;
    height: 100%;
    left: -430px;
    top: 0;
    position:absolute;

    -webkit-transition:.5s ease all;
    -moz-transition:.5s ease all;
    -o-transition:.5s ease all;
    transition:.5s ease all;
  }

  #container.display-nav #canvas {
    -webkit-transform:translateX(430px);
    -moz-transform:translateX(430px);
    -ms-transform:translateX(430px);
    -o-transform:translateX(430px);
    transform:translateX(430px);
  }

  #container.display-nav #nav {
    -webkit-transform-origin:100% 50%;
    -moz-transform-origin:100% 50%;
    -ms-transform-origin:100% 50%;
    -o-transform-origin:100% 50%;
    transform-origin:100% 50%;

    -webkit-transform:perspective(600px) rotateY(0deg);
    -moz-transform:perspective(600px) rotateY(0deg);
    -ms-transform:perspective(600px) rotateY(0deg);
    -o-transform:perspective(600px) rotateY(0deg);
    transform:perspective(600px) rotateY(0deg);
  }

  #bars{
    font-size: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    background-color: #F0F3F5;
  }

  #bars:hover{
    color: #48b978
  }

  .search-btn{
    margin-right: 0px;
  }

  #searchDiv{
    padding: 10px;
    background-color: #FFFFFF;
  }

  div.collapse-div >>> .is-active{
    color: black!important;
    background-color:#fff!important;
  }

  div.collapse-div >>> .el-collapse-item__arrow{
    margin-right: 20px;
  }

  .baseSetting .settingRow{
    padding: 8px;
  }

  .explain{
    color: #968092;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/terminal/TerminalEditLocationService.vue